import React from "react";
import insta from '../../assets/insta.svg'
import logo from '../../assets/logo.svg'
import Whatsapp from "../../assets/wa_Sood.svg"
import Saumya from "../../assets/hospital_logo.svg"
import "./footer.css"
function Footer() {
  return (<>
    <footer>
      <div className="left_footer">
        <img src={Saumya} alt="img" />
        <span>ENT Care Clinic</span>
      </div>
      <div className="right_footer">
        <div className="social_links">
          <img src={insta} alt="" onClick={() => { window.open("https://www.instagram.com/ent.care.clinic/") }} style={{ cursor: "pointer" }} />
          <img src={Whatsapp} alt="" onClick={() => { window.open("https://api.whatsapp.com/send/?phone=918707699762&text=9999202000%20press%20send%20to%20book%20appointment%20with%20Dr.%20Aashima%20%F0%9F%91%89") }} style={{ cursor: "pointer" }} />
        </div>
      </div>
    </footer>
    <div className="powered" onClick={() => { window.open("https://www.paperplanetech.co/") }} style={{ cursor: "pointer" }}>
      <span> Powered By</span>
      <img src={logo} alt="" />
    </div>
  </>
  );
}

export default Footer;
